// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 26 hooks for backend/disciplinary.

import { useBackend } from '../useBackend'

/** POST /api/disciplinary/amendDisciplinaryRecommendation */
export function useAmendDisciplinaryRecommendation<T = any>() {
  return useBackend<T>('disciplinary/amendDisciplinaryRecommendation')
}

/** POST /api/disciplinary/checkDisciplinarySignatures */
export function useCheckDisciplinarySignatures<T = any>() {
  return useBackend<T>('disciplinary/checkDisciplinarySignatures')
}

/** POST /api/disciplinary/closeDisciplinaryIncident */
export function useCloseDisciplinaryIncident<T = any>() {
  return useBackend<T>('disciplinary/closeDisciplinaryIncident')
}

/** POST /api/disciplinary/decideDisciplinaryCase */
export function useDecideDisciplinaryCase<T = any>() {
  return useBackend<T>('disciplinary/decideDisciplinaryCase')
}

/** POST /api/disciplinary/decideDisciplinaryRecommendation */
export function useDecideDisciplinaryRecommendation<T = any>() {
  return useBackend<T>('disciplinary/decideDisciplinaryRecommendation')
}

/** POST /api/disciplinary/dismissAutomatedSuggestion */
export function useDismissAutomatedSuggestion<T = any>() {
  return useBackend<T>('disciplinary/dismissAutomatedSuggestion')
}

/** POST /api/disciplinary/fileDisciplinaryRecommendation */
export function useFileDisciplinaryRecommendation<T = any>() {
  return useBackend<T>('disciplinary/fileDisciplinaryRecommendation')
}

/** POST /api/disciplinary/getDisciplinaryIncidentOptions */
export function useGetDisciplinaryIncidentOptions<T = any>() {
  return useBackend<T>('disciplinary/getDisciplinaryIncidentOptions')
}

/** POST /api/disciplinary/getDisciplinaryLetterPreview */
export function useGetDisciplinaryLetterPreview<T = any>() {
  return useBackend<T>('disciplinary/getDisciplinaryLetterPreview')
}

/** POST /api/disciplinary/getDisciplinaryPreview */
export function useGetDisciplinaryPreview<T = any>() {
  return useBackend<T>('disciplinary/getDisciplinaryPreview')
}

/** POST /api/disciplinary/getDisciplinaryRecommendations */
export function useGetDisciplinaryRecommendations<T = any>() {
  return useBackend<T>('disciplinary/getDisciplinaryRecommendations')
}

/** POST /api/disciplinary/getDisciplinarySuggestions */
export function useGetDisciplinarySuggestions<T = any>() {
  return useBackend<T>('disciplinary/getDisciplinarySuggestions')
}

/** POST /api/disciplinary/getDriverDisciplinaryIncidents */
export function useGetDriverDisciplinaryIncidents<T = any>() {
  return useBackend<T>('disciplinary/getDriverDisciplinaryIncidents')
}

/** POST /api/disciplinary/openDisciplinaryFile */
export function useOpenDisciplinaryFile<T = any>() {
  return useBackend<T>('disciplinary/openDisciplinaryFile')
}

/** POST /api/disciplinary/openDisciplinaryIncidentFile */
export function useOpenDisciplinaryIncidentFile<T = any>() {
  return useBackend<T>('disciplinary/openDisciplinaryIncidentFile')
}

/** POST /api/disciplinary/openDisciplinarySignedCopy */
export function useOpenDisciplinarySignedCopy<T = any>() {
  return useBackend<T>('disciplinary/openDisciplinarySignedCopy')
}

/** POST /api/disciplinary/recordDisciplinaryResponse */
export function useRecordDisciplinaryResponse<T = any>() {
  return useBackend<T>('disciplinary/recordDisciplinaryResponse')
}

/** POST /api/disciplinary/releaseAutomatedSuggestion */
export function useReleaseAutomatedSuggestion<T = any>() {
  return useBackend<T>('disciplinary/releaseAutomatedSuggestion')
}

/** POST /api/disciplinary/releaseDisciplinaryIncident */
export function useReleaseDisciplinaryIncident<T = any>() {
  return useBackend<T>('disciplinary/releaseDisciplinaryIncident')
}

/** POST /api/disciplinary/releaseDisciplinaryRecommendation */
export function useReleaseDisciplinaryRecommendation<T = any>() {
  return useBackend<T>('disciplinary/releaseDisciplinaryRecommendation')
}

/** POST /api/disciplinary/remindDisciplinaryRecommendation */
export function useRemindDisciplinaryRecommendation<T = any>() {
  return useBackend<T>('disciplinary/remindDisciplinaryRecommendation')
}

/** POST /api/disciplinary/reportDisciplinaryIncident */
export function useReportDisciplinaryIncident<T = any>() {
  return useBackend<T>('disciplinary/reportDisciplinaryIncident')
}

/** POST /api/disciplinary/sendDisciplinaryWarningLetter */
export function useSendDisciplinaryWarningLetter<T = any>() {
  return useBackend<T>('disciplinary/sendDisciplinaryWarningLetter')
}

/** POST /api/disciplinary/signDisciplinaryIncidentUpload */
export function useSignDisciplinaryIncidentUpload<T = any>() {
  return useBackend<T>('disciplinary/signDisciplinaryIncidentUpload')
}

/** POST /api/disciplinary/signDisciplinaryUpload */
export function useSignDisciplinaryUpload<T = any>() {
  return useBackend<T>('disciplinary/signDisciplinaryUpload')
}

/** POST /api/disciplinary/withdrawDisciplinaryRecommendation */
export function useWithdrawDisciplinaryRecommendation<T = any>() {
  return useBackend<T>('disciplinary/withdrawDisciplinaryRecommendation')
}
